/**
 * Tela honesta pro caso "logou mas não tem empresa ativa".
 *
 * Saiu de `App.tsx` em 26/08/2026: a página pública do relatório precisava de
 * duas linhas de rota, e `App.tsx` está na dívida do portão de tamanho — só
 * pode encolher. É movimentação de código, mesmo markup, mesmo comportamento.
 */
import { useAuth } from "../hooks/useAuth";
import { TEXTO_ERRO_EMPRESA } from "../lib/erroSessao";
import type { EmpresaErro } from "../hooks/useEmpresaAtiva";

/*
 * ANTES isto era o
 * "Carregando…" eterno com o menu curto: a pessoa ficava olhando um spinner que
 * nunca ia resolver, sem saber se era ela, a internet ou o sistema (incidente
 * 24/07). Cada causa agora diz o que é e o que fazer.
 */
export function EmpresaIndisponivel({ erro }: { erro: EmpresaErro }) {
  const { signOut } = useAuth();
  // A cópia mora em `lib/erroSessao` (fonte única) porque a frase sobre DATA E
  // HORA precisa de guarda: era ela que aparecia num 401 de infraestrutura e
  // mandava o dono conferir um relógio que estava certo (28/07 00:42).
  const texto = TEXTO_ERRO_EMPRESA[erro];

  return (
    <div className="flex min-h-screen items-center justify-center p-8">
      <div className="max-w-md space-y-4 text-center">
        <h1 className="text-xl font-semibold">{texto.titulo}</h1>
        <p className="text-sm text-muted-foreground">{texto.corpo}</p>
        <div className="flex justify-center gap-2 pt-2">
          <button
            className="rounded-md border px-4 py-2 text-sm"
            onClick={() => window.location.reload()}
          >
            Tentar de novo
          </button>
          <button
            className="rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground"
            onClick={() => { void signOut(); }}
          >
            Entrar de novo
          </button>
        </div>
      </div>
    </div>
  );
}
